import React from "react";

import {
  react,
  next_js,
  redux,
  redux_saga,
  angular,
  bootstrap,
  html,
  css,
  tailwindcss,
  material_ui,
  javascript,
  typescript,
  java,
  python,
  // php,
  nodejs,
  express,
  mongodb,
  mysql,
  github,
  adobe_xd,
  figma,
  photoshop,
  aws,
  heroku,
  stripe,
} from "assets/img/skills";

const skills = [
  { title: "React", icon: react },
  { title: "NextJs", icon: next_js },
  { title: "Redux", icon: redux },
  { title: "Redux Saga", icon: redux_saga },
  { title: "Angular", icon: angular },
  { title: "Bootstrap", icon: bootstrap },
  { title: "Html5", icon: html },
  { title: "CSS3", icon: css },
  { title: "TailwindCss", icon: tailwindcss },
  { title: "Material UI", icon: material_ui },
  { title: "Javascript", icon: javascript },
  { title: "Typescript", icon: typescript },
  { title: "Java", icon: java },
  { title: "Python", icon: python },
  // { title: "Php", icon: php },
  { title: "Nodejs", icon: nodejs },
  { title: "Express", icon: express },
  { title: "Mongodb", icon: mongodb },
  { title: "Mysql", icon: mysql },
  { title: "Github", icon: github },
  { title: "Adobe Xd", icon: adobe_xd },
  { title: "Figma", icon: figma },
  { title: "Photoshop", icon: photoshop },
  { title: "Aws", icon: aws },
  { title: "Heroku", icon: heroku },
  { title: "Stripe", icon: stripe },
];

const Skills = () => {
  return (
    <>
      {skills.map((val, i) => (
        <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
          <div className="d-flex justify-content-center ">
            <img
              className="skill-Icon bg-white p-1 skillsImgBg"
              style={{ borderRadius: "500px" }}
              src={val.icon}
              alt={val.title}
            />
          </div>
          <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
            {val.title}
          </h6>
        </div>
      ))}
    </>
  );
};

export default Skills;
